import {
    GET_MODEL_LISTING,
    GET_MODEL_LISTING_SUCCESS,
    GET_MODEL_LISTING_FAIL,
    GET_MODEL_DETAILS,
    GET_MODEL_DETAILS_SUCCESS,
    GET_MODEL_DETAILS_FAIL,
    ADD_MODEL,
    ADD_MODEL_SUCCESS,
    ADD_MODEL_FAIL,
    UPDATE_MODEL,
    UPDATE_MODEL_SUCCESS,
    UPDATE_MODEL_FAIL,
    DELETE_MODEL,
    DELETE_MODEL_SUCCESS,
    DELETE_MODEL_FAIL,
    EXPORT_MODEL,
    EXPORT_MODEL_SUCCESS,
    EXPORT_MODEL_FAIL,
    RESET_MODEL_STATE,
    RESET_MODEL_ATTACHMENT_STATE,
} from "./actionTypes";

export const getModelListing = model => ({
    type: GET_MODEL_LISTING,
    payload: model,
});

export const getModelListingSuccess = model => ({
    type: GET_MODEL_LISTING_SUCCESS,
    payload: model,
});

export const getModelListingFail = error => ({
    type: GET_MODEL_LISTING_FAIL,
    payload: error,
});

export const getModelDetails = modelId => ({
    type: GET_MODEL_DETAILS,
    payload: modelId,
});

export const getModelDetailsSuccess = model => ({
    type: GET_MODEL_DETAILS_SUCCESS,
    payload: model,
});

export const getModelDetailsFail = error => ({
    type: GET_MODEL_DETAILS_FAIL,
    payload: error,
});

export const createModel = model => ({
    type: ADD_MODEL,
    payload: model,
});

export const createModelSuccess = model => ({
    type: ADD_MODEL_SUCCESS,
    payload: model,
});

export const createModelFail = error => ({
    type: ADD_MODEL_FAIL,
    payload: error,
});

export const updateModel = model => ({
    type: UPDATE_MODEL,
    payload: model,
});

export const updateModelSuccess = model => ({
    type: UPDATE_MODEL_SUCCESS,
    payload: model,
});

export const updateModelFail = error => ({
    type: UPDATE_MODEL_FAIL,
    payload: error,
});

export const deleteModel = modelId => ({
    type: DELETE_MODEL,
    payload: modelId,
});

export const deleteModelSuccess = modelId => ({
    type: DELETE_MODEL_SUCCESS,
    payload: modelId,
});

export const deleteModelFail = error => ({
    type: DELETE_MODEL_FAIL,
    payload: error,
});

export const exportModel = data => ({
    type: EXPORT_MODEL,
    payload: data
});

export const exportModelSuccess = data => ({
    type: EXPORT_MODEL_SUCCESS,
    payload: data,
});

export const exportModelFail = error => ({
    type: EXPORT_MODEL_FAIL,
    payload: error,
});

//reset
export const resetModelState = () => {
    return {
        type: RESET_MODEL_STATE,
    }
}

//reset attachment
export const resetModelAttachmentState = () => {
    return {
        type: RESET_MODEL_ATTACHMENT_STATE,
    }
}

